import { computed } from '@ember/object';
import Service, { service } from '@ember/service';

import type { IntlService } from 'ember-intl';
import type MomentService from 'ember-moment/services/moment';

import type SessionService from 'umg-ember-backend/services/session';

export interface Locale {
  name: string;
  code: string;
  flag: string;
}

export default class LocaleService extends Service {
  // Services
  @service declare intl: IntlService;
  @service declare moment: MomentService;
  @service declare session: SessionService;

  // Defaults
  get availableLocales() {
    return [
      { name: 'Deutsch', code: 'de', flag: '🇩🇪' },
      { name: 'English', code: 'en', flag: '🇺🇸' },
    ] satisfies Locale[];
  }

  get browserLanguage() {
    return navigator.language.startsWith('de') ? 'de' : 'en';
  }

  // Getter, setter and computed properties
  @computed('availableLocales.[]', 'session.data.locale', 'browserLanguage')
  get currentLocale() {
    const locale = this.session.data?.locale || this.browserLanguage;
    return this.availableLocales.find((availableLocale) => {
      return availableLocale.code === locale;
    });
  }

  // Functions
  setup = (locale: string | null = null) => {
    locale = locale || this.session.data?.locale || this.browserLanguage;

    this.session.set('data.locale', locale);
    this.intl.setLocale(locale);
    this.moment.setLocale(locale);

    return locale;
  };
}

declare module '@ember/service' {
  interface Registry {
    locale: LocaleService;
  }
}
